// @flow
import licenseService from './licenseService';
import licenseActionKeys from './licenseActionKeys';

const getAtlasOrgStates = (serviceProviderId: number): any => ({
  type: licenseActionKeys.GET_ORG_STATES,
  payload: licenseService.getAtlasOrgStates(serviceProviderId),
});

const getAtlasOrgsByState = (serviceProviderId: number, stateId: number): any => ({
  type: licenseActionKeys.GET_ORGS_BY_STATE,
  payload: licenseService.getAtlasOrgsByState(serviceProviderId, stateId),
});

const getAtlasOrgFields = (serviceProviderId: number, orgId: string): any => ({
  type: licenseActionKeys.GET_ORG_FIELDS,
  payload: licenseService.getAtlasOrgFields(serviceProviderId, orgId),
});

const clearAtlasOrgs = (): any => ({
  type: licenseActionKeys.GET_ORGS_BY_STATE_RESET,
});

const clearAtlasOrgFields = (): any => ({
  type: licenseActionKeys.GET_ORG_FIELDS_RESET,
});

export default {
  getAtlasOrgStates,
  getAtlasOrgsByState,
  getAtlasOrgFields,
  clearAtlasOrgFields,
  clearAtlasOrgs,
};



// WEBPACK FOOTER //
// ./src/modules/profile/common/licenseActions.js